import { GET_SMS_HISTORY, GET_SMS_HISTORY_DETAILS } from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const smsHistorySlice = createCrudSlice({
  name: "smsHistory",
  urls: {
    getList: GET_SMS_HISTORY,
    getDetails: GET_SMS_HISTORY_DETAILS,
  },
});

// Export actions
export const { setFilter, resetFilters } = smsHistorySlice.actions;

// Export thunks
export const { getList: getSmsHistoryList, getDetails: getSmsHistoryDetails } =
  smsHistorySlice.thunks;

// Export reducer
export default smsHistorySlice.reducer;
